import { render, staticRenderFns } from "./ContentText.vue?vue&type=template&id=45391bb0"
import script from "./ContentText.vue?vue&type=script&lang=js"
export * from "./ContentText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports